<template>
  <modal name="order-modal"
         @closed="$emit('updateComparisonData')"
         @before-close="beforeClose"
         @before-open="beforeOpen"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Պայմանագրի մանրամասներ</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('order-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4 pb-0" style="overflow-x: auto; height: 90%">
      <table class="VueTables__table table table-striped table-bordered table-hover" style="overflow: hidden;">
        <thead>
            <tr>
              <th tabindex="0" title="" class="VueTables__sortable " style="position: relative;">
                  <div class="row justify-content-center">
                    <span class="VueTables__heading">Պայմանագրի ծածկագիր</span>
                  </div>
                  <div class="resize-handle" style="top: 0px; right: 0px; width: 5px; position: absolute; cursor: col-resize; user-select: none; height: 92px;"></div>
              </th>
              <th tabindex="0" title="" class="VueTables__sortable ">
                  <div class="row justify-content-center">
                    <span class="VueTables__heading">Մատակարար</span>
                  </div>
              </th>
              <th tabindex="0" title="" class="VueTables__sortable ">
                  <div class="row justify-content-center">
                    <span class="VueTables__heading">Հեռախոս</span>
                  </div>
              </th>
              <th tabindex="0" title="" class="VueTables__sortable ">
                  <div class="row justify-content-center">
                    <span class="VueTables__heading">Էլ. փոստ</span>
                  </div>
              </th>
            </tr>
        </thead>
        <tbody>
            <tr class="VueTables__row ">
              <td tabindex="0" class="">{{contract.code}}</td>
              <td tabindex="0" class="">{{contract.participant && contract.participant.name}}</td>
              <td tabindex="0" class="">{{contract.participant && contract.participant.phone}}</td>
              <td tabindex="0" class="">{{contract.participant && contract.participant.email}}</td>
            </tr>
        </tbody>
      </table>

      <v-client-table ref="vtable" :columns="columns" v-model="contract.lots" :options="options">
        <div slot="index" class="more d-flex justify-content-center" slot-scope="{row, index}">
          {{index}}
        </div>
        <div slot="id" slot-scope="{row}">
          {{ row.view_id }}
        </div>
        <div slot="cpv_name" slot-scope="{row}">
          {{row.name}}
        </div>
        <div slot="specification" slot-scope="{row}">
          {{row.specification}}
        </div>
        <div slot="purchase_schedule">
          Պատվերը ստանալուց՝ <span>{{ contract.organize && contract.organize.purchase_schedule || 5  }}</span> աշխատանքային օրվա ընթացքում
        </div>
        <div slot="unit_price" slot-scope="{row}">
          {{row.price_unit !== 0 ? row.price_unit : row.price / (row.available + row.ordered + row.supplied)}}դր.
        </div>
        <div slot="total_price" slot-scope="{row}">
          {{row.price}}դր.
        </div>
        <div slot="count" slot-scope="{row}">
          {{row.available + row.ordered + row.supplied}}
        </div>
        <div slot="leftover" slot-scope="{row}">
          {{row.available}}
        </div>
        <div slot="order_input" class="d-flex justify-content-center" slot-scope="{row}">
          <div v-if="row.available" class="row">
            <div class="col-12" v-tooltip="row.has_failed_order && 'Տվյալ չափաբաժնով կա չկայացած պատվեր'">
              <input
                :disabled="row.has_failed_order"
                v-model.number="row.order_count"
                @input="calculateByAvailable(row)"
                type="text"
                min="1"
                class="form-control"
              >
              <div :key="index">
                <span v-if="row.error" class="text-danger mb-0" style="font-size: 0.6rem">
                    գերազանցում է հասանելի մնացորդի քանակը
                </span>
              </div>
            </div>
          </div>
          <div v-else>
            Սպառված է
          </div>
        </div>
        <div slot="order_price" slot-scope="{row}">
          <div :key="index">
            {{row.order_price}}
          </div>
        </div>
      </v-client-table>
      
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <div class="col">
        <button @click="handleOpenOrderDetails" :disabled="Boolean(lotsWithError.length)" type="button" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
          Պատվիրել
        </button>
      </div>
      <button @click="$modal.hide('order-modal')" class="btn btn-light mr-3">
        Փակել
      </button>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'OrderModal',
  data () {
    return {
      isSetEqual: false,
      isSuccess: true,
      lotsWithError: [],
      columns: ['index', 'cpv_name', 'specification', 'unit', 'purchase_schedule', 'unit_price', 'total_price', 'count', 'leftover', 'order_input', 'order_price'],
      contract: {},
      lots: [],
      index: 0,
      focusedLotFields: {},
      lotsWithVatLength: 0,
      sugesstion: {},
      options: {
        sortable: [],
        perPage: 1000,
        perPageValues: [],
        columnsDropdown: false,
        filterByColumn: false,
        dateFormat: "YYYY-mm-dd",
        headings: {
          id: 'Չ/Հ',
          index: 'Հ/Հ',
          cpv_name: 'CPV - անվանում',
          specification: 'Բնութագիր',
          unit: 'Չափման միավորը',
          purchase_schedule: 'Մատակարարման ժամկետ',
          unit_price: 'Միավորի գինը',
          total_price: 'Ընդհանուր գինը',
          count: 'Ընդհանուր Քանակը',
          leftover: 'Մնացորդ',
          order_input: 'Պատվիրել',
          order_price: 'Պատվերի Գումարը',
        },
        filterable: false
      },
    }
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
  },
  methods: {
    consoleLog(data){
      console.log(data)
    },
    handleOpenOrderDetails(){
      if(this.$refs.vtable.filteredData.filter(row => row.order_count).length){
        this.$modal.show('order-details-modal', {handleOrder: this.order} )
      } else {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Ընտրեք գոնե մեկ չափաբաժին պատվերը գրանցելու համար',
          text: 'Կրկին փորձեք!'
        })
      }
    },
    async order(dispatchDate){
      const lots = []
      this.$refs.vtable.filteredData.filter(row => row.order_count).forEach((row) => {
        const lotObj = {
          contract_lot_id: row.id,
          ordered: row.order_count
        }
        lots.push(lotObj)
      })
      const requestData = {
        contract_id: this.contract.id,
        status: 'sended',
        dispatch_date: dispatchDate,
        lots: lots
      }
      await this.$client.post('contract-orders', requestData).then(({data}) => {
        if(data) {
          this.$router.push('/contractmanagement/orders/active')
        }
      }).catch(e => {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Ինչ որ բան այն չէ',
          text: 'Կրկին փորձեք!'
        })
      })
    },
    isAllRowsCorrect(){
      return true;
    },
    calculateByAvailable(row){
      const { available } = row;
      const orderCount = row.order_count;
      const priceUnit = row.price_unit;
      this.index = this.index + 1;
      this.lotsWithError = [];
      if(orderCount > available){
        this.lotsWithError.push(row);
        row.error = true;
        row.order_price = '';
      } else {
        const optionIndex = this.lotsWithError.findIndex(item => item.id === row.id)
        if(optionIndex >= 0){
          this.lotsWithError.splice(optionIndex, 1)
        }
        row.error = false;
        row.order_price = orderCount * priceUnit;
        this.lots.push(row)
      }
    },
    beforeClose(){
      this.$router.push({ path: '/contractmanagement/contracts/' })
    },
    beforeOpen({params}) {
      this.resetComponent = params.resetComponent
      this.contract = params.contract
      if(this.contract.organize.type === 'competitive'){
        this.columns = ['index', 'cpv_name', 'specification', 'unit', 'unit_price', 'total_price', 'count', 'leftover', 'order_input', 'order_price'];
      } else {
        this.columns = ['index', 'cpv_name', 'specification', 'unit', 'purchase_schedule', 'unit_price', 'total_price', 'count', 'leftover', 'order_input', 'order_price'];
      }
    },
    handleLotInputsFocus(event, details) {
      // eslint-disable-next-line eqeqeq
      if(event.target.value == 0) {
        event.target.select()
      }
      this.focusedLotFields = details
    },
  }
}
</script>
<style scoped>
  /deep/ .page-item {
      display: none;
  }
  /deep/ .vm--modal {
    top: 3rem !important;
    left: unset !important;
    width: 80% !important;
    /* height: auto !important; */
    margin: auto;
    padding-bottom: 70px;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
  .searchItem:hover {
    background-color: #1e7bb7;
    color: #fff;
  }
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .2s ease;
  }
  .component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>

